import React, { useEffect, useState } from 'react'
import { Container, Row, Col, OverlayTrigger, Tooltip, Button, Modal } from 'react-bootstrap'
import Card from '../../../components/Card'
import { Link } from 'react-router-dom'
import { useGetGhlAuthListMutation, useDeleteGhlAuthMutation, useGetGhlOAuthUrlMutation } from '../../../api/ghlAuthsAPISlices'
import CustomPagination from '../../../components/utility/CustomPagination'
import Toaster from '../../../components/utility/Toaster'

const columns = [
    { label: "Business Name", key: "business_name" },
    { label: "Location ID", key: "locationId" },
    { label: "Associated Users", key: "users" },
    { label: "Last Refreshed", key: "updated_at" },
    { label: "Action", key: "action" }
]

const SubaccountsList = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [subaccounts, setSubaccounts] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedSubaccount, setSelectedSubaccount] = useState(null);

    const [showToster, setShowToster] = useState(false);
    const [tosterMassage, setTosterMassage] = useState('');
    const [tosterStatus, setTosterStatus] = useState('');

    const [getGhlAuthList] = useGetGhlAuthListMutation();
    const [deleteGhlAuth] = useDeleteGhlAuthMutation();
    const [getGhlOAuthUrl] = useGetGhlOAuthUrlMutation();

    const token = JSON.parse(localStorage.getItem("token"));

    const getSubaccountsData = async () => {
        setIsLoading(true)
        await getGhlAuthList({ token, currentPage })
            .unwrap()
            .then((res) => {
                setSubaccounts(res)
                setIsLoading(false)
            })
            .catch((error) => {
                setShowToster(true)
                setTosterMassage(error?.data?.message || 'Error loading subaccounts')
                setTosterStatus('error')
                setIsLoading(false)
            })
    }

    useEffect(() => {
        getSubaccountsData()
    }, [currentPage])

    const onPageChange = (page) => {
        setCurrentPage(page);
    };

    const handleDeleteClick = (subaccount) => {
        setSelectedSubaccount(subaccount);
        setShowDeleteModal(true);
    };

    const handleDeleteConfirm = async () => {
        await deleteGhlAuth({ ghlAuthId: selectedSubaccount.id, token })
            .unwrap()
            .then((res) => {
                setShowDeleteModal(false);
                setShowToster(true)
                setTosterMassage('Subaccount deleted successfully')
                setTosterStatus('success')
                getSubaccountsData();
            })
            .catch((error) => {
                setShowDeleteModal(false);
                setShowToster(true)
                setTosterMassage(error?.data?.message || 'Error deleting subaccount')
                setTosterStatus('error')
            })
    };

    const handleAddSubaccount = async () => {
        await getGhlOAuthUrl({ token })
            .unwrap()
            .then((res) => {
                window.location.href = res.oauth_url;
            })
            .catch((error) => {
                setShowToster(true)
                setTosterMassage(error?.data?.message || 'Error getting OAuth URL')
                setTosterStatus('error')
            })
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleString();
    };

    const formatUsers = (users) => {
        if (!users || users.length === 0) {
            return <span className="text-muted">No users assigned</span>;
        }
        return users.map(user => user.name).join(', ');
    };

    return (
        <>
            <Container fluid>
                <Row>
                    <Col lg="12">
                        <div className="d-flex flex-wrap align-items-center justify-content-between my-schedule mb-4">
                            <div className="d-flex align-items-center justify-content-between">
                                <h4 className="font-weight-bold">Subaccounts</h4>
                            </div>
                            <div className="create-workform">
                                <div className="d-flex flex-wrap align-items-center justify-content-between">
                                    <div className="modal-product-search d-flex">
                                        <button
                                            onClick={handleAddSubaccount}
                                            className="btn btn-primary position-relative d-flex align-items-center justify-content-between"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" className="mr-2" width="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                            </svg>
                                            Add Subaccount
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {isLoading ?
                            (<div className='text-center mt-5 pt-5'>
                                <div className="spinner-border text-warning mr-2" role="status">
                                    <span className="visually-hidden"></span>
                                </div>
                            </div>)
                            : subaccounts?.data?.length > 0 ?
                                <>
                                    <Row>
                                        <Col lg="12">
                                            <Card className="card-block card-stretch border-back">
                                                <Card.Body className="p-0">
                                                    <div className="table-responsive">
                                                        <table className="table data-table mb-0">
                                                            <thead className="table-color-heading">
                                                                <tr className="text-center">
                                                                    {columns.map((col, i) => (
                                                                        <th key={i} scope="col">
                                                                            {col.label}
                                                                        </th>
                                                                    ))}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {subaccounts?.data?.map((row, index) => (
                                                                    <tr key={index} className="white-space-no-wrap">
                                                                        {columns.map((col) => (
                                                                            <td className='text-center' key={col.key}>
                                                                                {col?.key === 'action' ?
                                                                                    <div className="d-flex justify-content-center align-items-center">
                                                                                        <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>} >
                                                                                            <Link to={`/subaccounts-edit/${row?.id}`}>
                                                                                                <svg xmlns="http://www.w3.org/2000/svg" className="text-secondary mx-2" width="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                                                                </svg>
                                                                                            </Link>
                                                                                        </OverlayTrigger>
                                                                                        <OverlayTrigger placement="top" overlay={<Tooltip>Delete</Tooltip>} >
                                                                                            <button
                                                                                                className="btn btn-link p-0"
                                                                                                onClick={() => handleDeleteClick(row)}
                                                                                            >
                                                                                                <svg xmlns="http://www.w3.org/2000/svg" className="text-danger mx-2" width="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                                                                </svg>
                                                                                            </button>
                                                                                        </OverlayTrigger>
                                                                                    </div>
                                                                                : col?.key === 'users' ?
                                                                                    formatUsers(row?.users)
                                                                                : col?.key === 'updated_at' ?
                                                                                    formatDate(row?.updated_at)
                                                                                : col?.key === 'locationId' ?
                                                                                    <code>{row?.locationId}</code>
                                                                                : col?.key === 'business_name' ?
                                                                                    row?.business_name || <span className="text-muted">-</span>
                                                                                : row?.[col?.key] || ''
                                                                                }
                                                                            </td>
                                                                        ))}
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col lg="12" className='text-center'>
                                            <CustomPagination
                                                current_page={currentPage}
                                                last_page={subaccounts?.meta?.last_page}
                                                onPageChange={onPageChange}
                                            />
                                        </Col>
                                    </Row>
                                </> :
                                <div className='pt-5 mt-5 mb-5 text-center'>
                                    No subaccounts found
                                </div>
                        }
                    </Col>
                </Row>
            </Container>

            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete this subaccount? This will disconnect the GHL integration.
                    <div className="mt-3">
                        <strong>Location ID:</strong> {selectedSubaccount?.locationId}
                    </div>
                    {selectedSubaccount?.users?.length > 0 && (
                        <div className="mt-2">
                            <strong>Associated Users:</strong> {selectedSubaccount?.users?.map(u => u.name).join(', ')}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDeleteConfirm}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>

            <Toaster status={tosterStatus} message={tosterMassage} show={showToster} setShow={setShowToster} />
        </>
    )
}

export default SubaccountsList;
